import React, { useState, useEffect } from 'react';
import Header from '../common/header';
import Sidebar from '../common/navBar';
import CommonCard from '../common/commonCard';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from '../common/footer';
import { GetFormationVideosService } from '../../Services/formationVideoService';
import FormationVideos from '../specific/formationVideos';
import { useTranslation } from "react-i18next";

const Formation = () => {
  const [t] = useTranslation("formation")
  const [expanded, setExpanded] = useState(false);
  const [videos, setVideos] = useState([]);


  const [loading, setLoading] = useState(true);


  async function fetchData() {
    setLoading(true)
    try {
      setVideos([])
      const response = await GetFormationVideosService();

      setVideos(response);
      setLoading(false)

    } catch (error) {
      setLoading(false)
      console.error('Hubo un error al obtener las formaciones', error);
    }
  }

  const handleReloadData = () => {

    fetchData();
  };

  useEffect(() => {

    fetchData();
  }, []);


  return (
    <div>
      <Header
        manual={'https://www.myreportin.com/descargas/manual-de-usuario-Myreportin.pdf'}
        reloadData={handleReloadData}
      />
      <Container fluid>
        <Row>
          <Col className='d-flex' style={{ paddingLeft: 0, paddingRight: 0, flex: `0 0 ${expanded ? '2%' : '4%'}` }}>
            <Sidebar expanded={expanded} setExpanded={setExpanded} selected={'Formación'} />
          </Col>
          <Col className='custom-content-wrapper' style={{ marginLeft: `0.5%`, paddingRight: 0, flex: `0 0 ${expanded ? '88%' : '93%'}` }}>
            <CommonCard title={t("card.title")} icon={"FaGraduationCap"}>
              <div className='width-95 mx-auto'>
                <p className=' pt-4 font-bold color-darkest-gray'>{t("formation.title")}</p>

                <FormationVideos data={videos} key={loading}/>
              </div>
            </CommonCard>


            <Footer />
          </Col>

        </Row>
      </Container>
    </div>
  );
}

export default Formation;